export const environment = {
  production: true,
  apiUrl: 'https://proto-api1.ibercon.org',
};
